import axios from 'axios';

export default class SelectService {

    public static selectList(file) {
        return axios.get('/select/' + file + '/selectList');
    }

}
